var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "level" }, [
    _c("div", { staticClass: "level-left" }, [
      _c(
        "h1",
        { staticClass: "title", class: _vm.size },
        [
          _vm.icon
            ? _c("dc-icon", { attrs: { icon: _vm.icon, "no-margin": "" } })
            : _vm._e(),
          _vm._v(" " + _vm._s(_vm.heading) + " "),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "level-right" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }